import { configAxiosBase, configAxiosBaseBufferArray } from '@/utils/api-instance';
import { ENDPOINTS } from '@/utils/constants';

export const getStatisticsOpportunities = async daysAgo => {
    const api = configAxiosBase();
    const { data } = await api.get(ENDPOINTS.OPPORTUNITIES_STATISTICS + '?days_ago=' + daysAgo);
    return { data };
};
export const exportQuotationPdf = async id => {
    const api = configAxiosBaseBufferArray();
    const { data } = await api.get(ENDPOINTS.EXPORT_QUOTATIONS_PDF + id);
    return data;
};
